import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Link as ChakraLink} from '@chakra-ui/react'
import {Link as RouterLink} from 'react-router-dom'

const CustomLink = ({
    isExternal,
    asButton = false,
    href = '#',
    children,
    variant,
    isNewsletter,
    ...rest
}) => {
    if (asButton) {
        if (isExternal) {
            return (
                <Button variant={variant} as={ChakraLink} href={href} isExternal {...rest}>
                    {children}
                </Button>
            )
        }
        return (
            <Button
                id={isNewsletter ? 'js-show-newsletter-popup' : undefined}
                variant={variant}
                as={RouterLink}
                to={href}
                {...rest}
            >
                {children}
            </Button>
        )
    }
    if (isExternal) {
        return (
            <ChakraLink href={href} isExternal {...rest}>
                {children}
            </ChakraLink>
        )
    }

    if (!href)
        return (
            <Box as="span" {...rest}>
                {children}
            </Box>
        )

    return (
        <ChakraLink as={RouterLink} to={href} {...rest}>
            {children}
        </ChakraLink>
    )
}

CustomLink.propTypes = {
    isExternal: PropTypes.bool,
    asButton: PropTypes.bool,
    href: PropTypes.string,
    variant: PropTypes.string,
    isNewsletter: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default CustomLink
